import React from 'react';
import styled from 'astroturf/react';
import Button from 'src/components/Button';
import TextField from 'src/components/TextField';
import Form from 'src/components/Form';

const ResourceDiv = styled('div')`
  display: flex;
  background-color: var(--white);
  outline: #efefef solid 5px;
  border: 2px solid #efefef;
  margin-bottom: 10px;

  & + & {
    margin: 10px 0;
  }
`;

const Row = styled('div')`
  display: block;
  width: 100%;
  white-space: nowrap;

  &.paddingForButtons {
    padding-top: 20px;
  }

  &.action-button-row {
    height: 34px;
    display: flex;
    align-items: center;
  }
`;

const RadioGroupInput = styled('input')`
  opacity: 0;
  position: absolute;
  z-index: -1;

  &:checked + [class*='RadioGroupCircle'] {
    border: solid 6px orange;
    border-color: var(--ph-orange-500);
  }
`;

const RadioGroupCircle = styled('div')`
  width: 16px;
  height: 16px;
  margin-right: 6px;
  border: 1px solid rgba(var(--ph-gray-rgb-500), 0.4);
  border-radius: 50%;
  background-color: var(--white);
`;

const RadioGroupText = styled('span')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--charcoal-grey);
`;

const RadioGroupItem = styled('label')`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 3px;
`;

const DivRow = styled('div')`
  display: block;
  width: calc(100% - 30px);
  white-space: nowrap;
  min-height: 36px;

  & + & {
    margin-top: 22px;
  }

  &.half {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &.half > label {
    width: calc(50% - 15px);
  }

  div[class*="react_component_tooltip"] {
    white-space: normal;
    max-width: 50%;
  }

  div[class*="textFieldLabel"] {
    padding-top: 6px;
  }

  input[class*="textFieldInput"] {
    min-height: 36px;
  }

  div[class*="SelectBoxLabel"],
  div[class*="textFieldLabel"] {
    flex: 0 0 100px;
  }

  span[class*="SelectBoxRequired"],
  span[class*="textFieldRequired"] {
    top: 0;
    margin-right: 10px;
  }

  @media (max-width: 991px) {
    &.half > label {
      width: calc(100%);
    }
  }
`;

const LeftColumn = styled('div')`
  flex: 1;
  min-width: 0;
  padding: 0 0 0 0;
  display: flex;
  background: #efefef;
`;

const LeftColumnRows = styled('div')`
  padding: 15px;
  flex: 5;
  width: 100%;
  background: white;
  border-left: solid 1px #b2b3b2;
  border-top: solid 1px #b2b3b2;
  border-bottom: solid 1px #b2b3b2;
`;

const CenterColumn = styled('div')`
  flex: 2;
  padding: 20px;
  border-top: solid 1px #b2b3b2;
  border-bottom: solid 1px #b2b3b2;
`;

const RightColumn = styled('div')`
  flex: 1;
  padding: 20px;
  min-width: 0;
  position: relative;
  border-right: solid 1px #b2b3b2;
  border-top: solid 1px #b2b3b2;
  border-bottom: solid 1px #b2b3b2;
`;

const RadioGroupItemRow = styled('div')`
  display: inline-block;

  & + & {
    margin-left: 10px;
  }
`;

const ActionResourceHintTextDiv = styled('div')`
  flex: 1;
  background: #efefef;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 17px;
`;
const ActionResourceHintText = styled('div')`
  transform: rotate(270deg);
  opacity: 0.4;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 1px;
  position: absolute;
  top: 2.8rem;

  &.lang-cn {
    transform: rotate(90deg);
  }
`;

const ErrorText = styled('span')`
  font-size: var(--ph-text-sm);
  color: var(--ph-red-300);
`;

const SaveButton = styled(Button)`
  &.disabled {
    background-color: var(--ph-gray-200) !important;
    cursor: not-allowed;
  }
`;

const FormTextField = styled(TextField)`
  &.autoMinWidth div[class*="textFieldLabel"] {
    min-width: auto;
  }

  &.grayedOut > input {
    background-color: var(--ph-gray-50);
    color: var(--ph-gray-300);
  }

  &.grayedOut > textarea {
    background-color: var(--ph-gray-50);
    color: var(--ph-gray-300);
  }
`;

const ResourceForm = styled(Form)`
  display: flex;
`;

export default {
  ActionResourceHintText,
  ActionResourceHintTextDiv,
  CenterColumn,
  FormTextField,
  DivRow,
  ErrorText,
  LeftColumn,
  LeftColumnRows,
  ResourceDiv,
  RightColumn,
  Row,
  RadioGroupItem,
  RadioGroupInput,
  RadioGroupItemRow,
  RadioGroupCircle,
  RadioGroupText,
  SaveButton,
  ResourceForm,
};
